<div
  style="
    width: 1123px;
    height: 794px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-family: Arial, Helvetica, sans-serif;
    padding: 64px;
  "
>
  <div style="display: flex; justify-content: space-between; padding-bottom: 106px; align-items: flex-end">
    <div style="font-size: 18px; font-weight: bold; color: gray; padding-left: 64px; padding-bottom: 28px;">
      CERTIFICATE OF COMPLETION
    </div>
    <div style="width: 400px">
      <img src="../../../assets/images/LANDSCAPE - LOGO.jpg" style="width: 100%;" alt="">
    </div>
  </div>
  <div style="background: #f3f3f3; border-radius: 10px; padding: 64px; position: relative;">
    <div style="color: #3a6183; font-size: 24px; font-weight: 500; padding-bottom: 24px">
      This is to certify that
    </div>
    <div style="font-size: 40px; color: #3a6183; font-weight: bold; padding-bottom: 24px">
      First Name Last Name
    </div>
    <div style="font-size: 24px; color: #3a6183; font-weight: 500;" >
      has successfully completed <span style="font-style: italic;">
      'The Complete Blood Count'
      </span>&nbsp;with
    </div>
    <div style="font-size: 24px; color: #3a6183; font-weight: bold; padding-bottom: 2rem">
      The <span style="color: rgb(255, 174, 0)">Lab</span>oratory Matters 
    </div>
    <div style="font-size: 18px; color: gray">
      Instructors <span style="font-weight: bold;">Dr. Rani</span>
    </div>
    <div style="font-size: 18px; color: gray">
      Length <span style="font-weight: bold;">16 Hrs</span>
    </div>
    <div style="font-size: 18px; color: gray">
      Dated <span style="font-weight: bold;">27 Oct., 2022</span>
    </div>
    <div class="signature" style="position: absolute; right: 10px; bottom: 60px;">
      <img src="../../../assets/images/rani_sign.png" alt="" style="width: 400px;">
      <div style="font-size: 16px; color: gray; font-weight: bold; text-align: center;">(Dr. Rani Radhakrishnan)</div>
    </div>
  </div>
</div>
